import { makeStyles, Paper } from "@material-ui/core";
import { SectionM24Step } from "components/request-document/StepContainer";
import { M24_CONFIG_DOC } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { get } from "lodash";
import AdminButtonController from "pages/admin/smart-visa/AdminButtonController";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAllDocumentsList,
  setDocDetail,
} from "redux/modules/allDocumentsSlice";
import { getPersonalDetail } from "redux/modules/personalSlice";
import { getSmartCompany } from "redux/modules/smartCompanySlice";
import { initRouter, setM24, setSmartFormStep } from "redux/modules/uiSlice";
import {
  getDocumentRequired,
  getSmartForm,
  setSmartFormSetDraftId,
  setSmartServiceId,
} from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  paper: {
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
    // marginBottom: 60
  },
  wrapBtnControl: {
    width: "100%",
    bottom: 0,
    backgroundColor: "white",
    zIndex: 1,
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "10px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    padding: "15px",
    position: "sticky",
    marginTop: "30px",
  },
}));

function DocumentDetailPage() {
  const classes = useStyles();
  let { draftId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoadind] = useState(false);
  const userProfile = useSelector((state) => state.user.profile);
  const smartCompanyID = get(userProfile, "smartCompanyID", null);
  const smartserviceId = M24_CONFIG_DOC.COC.SMART_SERVICE_ID;
  const ConditionType = M24_CONFIG_DOC.COC.CONDITION_TYPE;
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();

  useEffect(async () => {
    async function fetchData() {
      // dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
      // dispatch(setSmartFormStep(SMART_T_STEP.INSTITUTION_COMPANY));

      try {
        dispatch(setM24(true));
        dispatch(
          initRouter([
            SMART_T_STEP.INSTITUTION_COMPANY,
            SMART_T_STEP.COMPANY_UPLOAD_DOCUMENT,
            SMART_T_STEP.PART_A_1,
            SMART_T_STEP.PART_A_2,
            SMART_T_STEP.UPLOAD_DOCUMENT,
          ])
        );
        dispatch(setSmartFormStep(SMART_T_STEP.INSTITUTION_COMPANY));

        const res = await dispatch(getAllDocumentsList({ draftId }));
        if (res.payload && res.payload.length > 0) {
          const detail = res.payload[0];

          await dispatch(getPersonalDetail({ personalId: detail.personalId }));

          dispatch(getSmartCompany(detail.smartCompanyID));
          dispatch(setSmartServiceId(detail.smartserviceId));
          dispatch(
            getSmartForm({
              personalId: detail.personalId,
              // smartserviceId: detail.smartserviceId,
              draftId: detail.draftId,
            })
          );
          dispatch(setDocDetail(detail));

          dispatch(setSmartFormSetDraftId(draftId));
        }
      } catch (error) {
        console.error(error);
      }
    }
    showAdminLoading();
    await fetchData();
    setLoadind(true);
    hideAdminLoading();
  }, [dispatch, draftId]);

  useEffect(() => {
    dispatch(getDocumentRequired({ smartserviceId, ConditionType }));
    dispatch(getSmartCompany(smartCompanyID));
  }, [dispatch, draftId, getSmartForm, smartserviceId]);

  return (
    <Paper className={classes.paper} id="admin-view">
      {loading && (
        <>
          <SectionM24Step />
          {/* <StepContainer /> */}
          {/* <div className={classes.wrapBtnControl}>
        test
      </div> */}

          <div className={classes.wrapBtnControl}>
            <AdminButtonController />
          </div>
        </>
      )}
    </Paper>
  );
}

export default DocumentDetailPage;
